import React from 'react';
import { strings } from '@goodfynd/strings';
import { Text } from '@goodfynd/ui';

import { StyledDiv } from './styles';
import type { ReviewTextProps } from './types';

export function ReviewTextField({ css, label, value }: ReviewTextProps) {
  return (
    <StyledDiv css={css}>
      <Text as="subhead3">{label}</Text>
      {typeof value === 'string' ? (
        <Text as="body2">{value}</Text>
      ) : (
        value ?? <Text as="body2">{strings.labels.notProvided}</Text>
      )}
    </StyledDiv>
  );
}
